import Blockies from "./Blockies";

export default Blockies;
